<template>
  <div>
    <div class="controlls">
      <a href=# class="pause dark"></a>
    </div>
    <button v-on:click="isNavOpen = !isNavOpen" class="topnav-button dark"><span></span></button>
    <div :class="[{ 'active': isNavOpen }, 'topnav']">
      <div class="topnav-wrapper">
        <ul class="topnav-menu">
        <li><a href=#music>Music</a></li>
        <li><a href=#history>History</a></li>
        <li><a href=#mailinglist>Mailinglist</a></li>
        <li><a href=#contact>Contact</a></li>
        <li class="topnav-social">
          <a target="_blank" href="https://www.facebook.com/Eight-Bit-Tiger-112557322147662/" class="external-link">
            <i class="fi-social-facebook"></i>
          </a>
          <a target="_blank" href=https://twitter.com/eightbittiger class="external-link">
            <i class="fi-social-twitter"></i>
          </a>
          <a target="_blank" href="https://instagram.com/eightbittiger/" class="external-link">
            <i class="fi-social-instagram"></i>
          </a>
          <a
            target="_blank"
            href="https://play.spotify.com/artist/1ywZMLc9BKOYF0N2VxnANF?play=true&amp;utm_source=open.spotify.com&amp;utm_medium=open"
            class="external-link"
          >
            <i class="fi-social-spotify"></i>
          </a>
        </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
      isNavOpen: false,
    };
  },
  watch: {
    isNavOpen(val) {
      const htmlEl = document.getElementsByTagName('html')[0];
      if (val) {
        htmlEl.classList.add('no-scroll', 'nav-open');
      } else {
        htmlEl.classList.remove('no-scroll', 'nav-open');
      }
    },
  },
};
</script>
